import React, { useEffect, useState } from 'react'
import axios from 'axios'
import '../../../styles/Actualite.css'

function Actualite() {
  const [itemsactualite, setItemsActualite] = useState([])

  useEffect(() => {
    axios
      .get('./json/itemsactualite.json', {
        headers: {
          'Cache-Control': 'no-cache',
        },
      })
      .then(function (response) {
        setItemsActualite(response.data)
      })
      .catch(function (error) {
        console.error('Erreur lors de la mise à jour des données JSON', error)
      })
  }, [])

  return (
    <div id="Accueil" className="accueil">
      <div>
        <div className="blockTitle">
          <h1>Cours de danse - Blanquefort</h1>
        </div>
      </div>
      <div id="section-accueil" className="sectionAccueil">
        <div id="texte-accueil" className="containerTexteAccueil">
          <div id="text_Accueil-titre" className="textTitre">
            DUO DANSE
          </div>
          <div id="text_Accueil-1" className="blockText">
            <p>
              L'association DUO DANSE est née de l'envie d'amoureux des danses à
              deux de faire partager leur passion.
              <br />
              <br />
              Vous y trouverez une équipe à l'écoute, des professeurs attentifs
              à vos besoins, des cours adaptés à votre niveau, et surtout une
              ambiance toujours conviviale pour vous immerger dans les Danses de
              Salon, le Rock, la Salsa et le West Coast Swing.
              <br />
              <br />
              Emmené par Audrey Bourgeois notre professeur diplomée, venez
              découvrir, vous initier, progresser, vous perfectionner et surtout
              vous amuser dans nos cours, nos stages, nos soirées et toutes nos
              manifestations.
            </p>
          </div>
          <div id="text_Accueil-2" className="blockText">
            <blockquote>
              <p>Nous vous attendons avec plaisir et impatience !!!!!</p>
            </blockquote>
          </div>
        </div>
        <div id="Actualite" className="sectionActualite">
          <div className="blocInfo">
            <div className="cellTitreInfo">
              <h1>ACTUALITE.</h1>
              <p>
                <br />
                <b>
                  <i>Cliquez sur les dates pour plus d'informations.</i>
                </b>
              </p>
            </div>
            {itemsactualite.map((item) => (
              <div key={item.id}>
                <div className="cellInfo">
                  <div className="cellDate">
                    <a href={item.lien}>
                      <p className="jour">{item.jour}</p>
                      <p className="mois">{item.mois}</p>
                    </a>
                  </div>
                  <div className="cellInfoDate">
                    <div className="texteAnnonce">
                      <p dangerouslySetInnerHTML={{ __html: item.annonce }} />
                    </div>
                  </div>
                  <div className="separationActualite"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Actualite
